import React from 'react'
import AppModal from '../common/AppModal'
import CreateOrUpdatePaymentMethodForm from '../../forms/CreateOrUpdatePaymentMethodForm'

interface CreatePaymentMethodModalProps {
  open: boolean
  onClose: () => void
  loading: boolean
  error: string | null
}

const CreatePaymentMethodModal: React.FC<CreatePaymentMethodModalProps> = ({
  open,
  onClose,
  loading,
  error
}) => (
  <AppModal open={open} onClose={onClose} title="Add Payment Method" width="md" loading={loading}>
    <CreateOrUpdatePaymentMethodForm loading={loading} error={error} />
  </AppModal>
)

export default CreatePaymentMethodModal
